import Accordion from './_accordion'
import TabbedContent from './_tabbed-content'
import getRequestParams from '../utilities/get-request-params'

const TabbedContentAccordion = function () {
	this.controller = null

	this.mode = null

	this.root = null

	this.slices = []

	this.activeIndex = -1

	this.templates = {
		accordion: {
			container: '<div class="accordion js-accordion">%items%</div>',
			item: '<div class="accordion__item" data-accordion-id="accordion-item-%id%">' + '  <h3 class="accordion__item-title">' + '      <button class="js-accordion-item" data-accordion-id="accordion-item-%id%" %tabAnchorId%>%title%</button>' + '  </h3>' + '  <div class="accordion__item-content">%blocks%</div>' + '</div>',
		},
		tabbedContent: {
			container: '<div class="tabbed-content js-tabbed-content %tabFontSize%">%tabs%%panels%</div>',
			tabsList: '<ul class="tabbed-content__tabs js-tabs">%items%</ul>',
			tabItem: '<li>' + '  <button class="js-tab %activeClass%" data-index="%index%" type="button" aria-controls="%id%" aria-expanded="%expanded%" %tabAnchorId%>%title%</button>' + '</li>',
			panel: '<div class="tabbed-content__panel js-panel %activeClass%" id="%id%">' + '   <div class="column-blocks">%blocks%</div>' + '</div>',
		},

		general: {
			img: '<img src="%src%" alt="%alt%" />',
			video: '<video playsinline autoplay muted loop src="%src%"></video>',
			videoEmbed: '<div class="video-container">%iframe%</div>',
			vimeoIframe: '<iframe src="https://player.vimeo.com/video/%slug%" width="560" height="315" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>',
			youtubeIframe: '<iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/%slug%" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>',

			icon: '<div class="column-blocks__icon">%img%</div>',
			link: '<a href="%href%" class="%class%">%text%</a>',

			columnBlocks: '<div class="column-blocks">%img%%content%</div>',
			imageColumn: '<div class="column-blocks__image">%img%</div>',
			contentColumn: '<div class="column-blocks__copy">' + '     <div class="body-copy u-width-narrow">%icon%%content%%link%%featuredStory%</div>' + '</div>',

			sidebarColumn: '<div class="column-blocks__sidebar body-copy">%sidebar%</div>',

			featuredStory: '<a href="%href%" target="%target%" class="card">' + ' <div class="card__prompt">Or learn more about:</div>' + ' <div class="card__body">' + '     <div class="card__image"><img src="%img%" alt=""></div>' + '     <div class="card__content">' + '         <h3>%title%</h3>' + '     </div> ' + ' </div>' + '</a>',
		},
	}

	this.makeSafeIdString = function (title) {
		return title.replace(/\s/g, '').replace('&', '').replace('/', '')
	}

	this.updateItemIndex = function (e) {
		const itemIndex = e.detail.itemIndex
		this.activeIndex = this.activeIndex === itemIndex ? -1 : itemIndex
	}

	this.setActiveItem = function () {
		if (this.activeIndex !== -1) {
			var selector = this.mode === 'accordion' ? 'button[data-accordion-id="accordion-item-' + this.activeIndex + '"]' : 'button[data-index="' + this.activeIndex + '"]'

			const activeItem = this.root.querySelector(selector)

			if (activeItem) {
				activeItem.click()
			}
		}
	}

	this.resize = function () {
		const newMode = window.matchMedia('(max-width: 768px)').matches ? 'accordion' : 'tabbed'

		if (newMode !== this.mode) {
			this.mode = newMode
			this.build()
		}
	}

	this.build = function () {
		this.mode === 'accordion' ? this.buildAccordion() : this.buildTabbedContent()
	}

	this.buildAccordion = function () {
		let html = this.templates.accordion.container

		let items = this.slices.map((slice, index) => {
			const id = 'accordion-item-' + index
			const tabAnchorId = slice.tab_anchor_id ? `id="${slice.tab_anchor_id}"` : ''

			const blocks = this.buildBlocks(slice)

			return this.templates.accordion.item.replace(/%id%/g, id).replace('%title%', slice.tab_title).replace('%tabAnchorId%', tabAnchorId).replace('%blocks%', blocks)
		})

		html = html.replace('%items%', items.join(''))

		this.root.innerHTML = ''
		this.root.insertAdjacentHTML('afterbegin', html)

		// tear down a previous instance
		if (this.controller !== null && this.controller.destroy) {
			this.controller.destroy()
		}

		this.controller = new Accordion()
		this.controller.scrollOnExpand = true
		this.controller.init(this.root.querySelector('.js-accordion'), this.setActiveItem.bind(this))
	}

	this.buildTabbedContent = function () {
		// container
		let html = this.templates.tabbedContent.container

		// tabs container
		let tabsList = this.templates.tabbedContent.tabsList

		// tabs
		const tabs = this.slices.map((slice, index) => {
			const active = index === 0 ? 'is-active' : ''
			const id = this.makeSafeIdString(slice.tab_title)
			const tabAnchorId = slice.tab_anchor_id ? `id="${slice.tab_anchor_id}"` : ''

			const expanded = index === 0 ? 'true' : 'false'
			return this.templates.tabbedContent.tabItem.replace('%activeClass%', active).replace('%id%', id).replace('%index%', index).replace('%expanded%', expanded).replace('%title%', slice.tab_title).replace('%tabAnchorId%', tabAnchorId)
		})

		// add tabs
		tabsList = tabsList.replace('%items%', tabs.join(''))

		let panels = this.slices.map((slice, index) => {
			const blocks = this.buildBlocks(slice)
			const active = index === 0 ? 'is-active' : ''
			const id = this.makeSafeIdString(slice.tab_title)

			return this.templates.tabbedContent.panel.replace('%activeClass%', active).replace('%id%', id).replace('%blocks%', blocks)
		})

		html = html
			.replace('%tabFontSize%', 'tabbed-content--' + this.tabFontSize)
			.replace('%tabs%', tabsList)
			.replace('%panels%', panels.join(''))

		this.root.innerHTML = ''
		this.root.insertAdjacentHTML('afterbegin', html)

		// tear down a previous instance
		if (this.controller !== null && this.controller.destroy) {
			this.controller.destroy()
		}

		this.controller = new TabbedContent()
		this.controller.init(this.root.querySelector('.js-tabbed-content'), this.setActiveItem.bind(this))
	}

	this.buildMedia = function (slice) {
		var media = ''
		switch (slice.image_video) {
			case 'image':
				media = this.buildImage(slice)
				break

			case 'video': // Uploaded Video (File)
				media = this.buildVideo(slice)
				break

			case 'embedded_video': // Embedded Video (YouTube/Vimeo)
				media = this.buildEmbeddedVideo(slice)
				break
		}

		return media
	}

	this.buildImage = function (slice) {
		var img = ''
		if (slice.image_conditional && slice.image_conditional.url.length) {
			img = this.templates.general.img.replace('%src%', slice.image_conditional.url).replace('%alt%', slice.image_conditional.alt)

			return this.templates.general.imageColumn.replace('%img%', img)
		}

		return false
	}

	this.buildVideo = function (slice) {
		var video = ''
		if (slice.video && slice.video.url.length) {
			video = this.templates.general.video.replace('%src%', slice.video.url)
			return this.templates.general.imageColumn.replace('%img%', video)
		}

		return false
	}

	this.buildEmbeddedVideo = function (slice) {
		var iframe = ''
		var autoplay = slice.autoplay_video
		var url = slice.embedded_video
		var slug = this.getVideoSlug(url) + '?'

		// Vimeo
		if (url.indexOf('vimeo') !== -1) {
			// if autoplay was toggled on, autoplay/mute
			if (autoplay) {
				slug += 'autoplay=1&muted=1'
			}
			iframe = this.templates.general.vimeoIframe.replace('%slug%', slug)
			var video = this.templates.general.videoEmbed.replace('%iframe%', iframe)
			return this.templates.general.imageColumn.replace('%img%', video)
		}

		// YouTube
		else if (url.indexOf('//you') !== -1) {
			// remove excessive branding and ditch those follow up video suggestions
			slug += 'modestbranding=1&rel=0'

			// add autoplay/mute flags if autoplay was toggled on
			if (autoplay) {
				slug += '&autoplay=1&mute=1'
			}

			iframe = this.templates.general.youtubeIframe.replace('%slug%', slug)
			var video = this.templates.general.videoEmbed.replace('%iframe%', iframe)
			return this.templates.general.imageColumn.replace('%img%', video)
		}

		return false
	}

	this.buildContent = function (slice) {
		// if there's no content, then the column media will be 100% width
		if (!slice.content) return false

		let link = ''
		let icon = ''
		let featuredStory = ''

		if (slice.link) {
			var classes = slice.link_as_button ? 'button button--inline trackable-button' : 'learn-more trackable-button'
			link = this.templates.general.link.replace('%href%', slice.link.url).replace('%class%', classes).replace('%text%', slice.link.title)
		}

		if (slice.icon.url) {
			var img = this.templates.general.img.replace('%src%', slice.icon.url).replace('%alt%', slice.icon.alt)
			icon = this.templates.general.icon.replace('%img%', img)
		}

		if (slice.featured_story) {
			featuredStory = this.buildFeaturedStory(slice)
		}

		return this.templates.general.contentColumn.replace('%icon%', icon).replace('%content%', slice.content).replace('%link%', link).replace('%featuredStory%', featuredStory)
	}

	this.buildSidebar = function (slice) {
		let sidebar = ''

		if (slice.sidebar_content) {
			sidebar = this.templates.general.sidebarColumn.replace('%sidebar%', slice.sidebar_content)
		}
		return sidebar
	}

	this.buildFeaturedStory = function (slice) {
		let featuredStory = ''

		if (slice.featured_story) {
			featuredStory = this.templates.general.featuredStory.replace('%href%', slice.featured_story.story_link).replace('%target%', slice.featured_story.target).replace('%img%', slice.featured_story.img).replace('%title%', slice.featured_story.title)
		}
		return featuredStory
	}

	this.buildBlocks = function (slice) {
		var content = this.buildContent(slice)
		var media = this.buildMedia(slice)
		var sidebar = this.buildSidebar(slice)

		var elements = []

		if (content) elements.push(content)
		if (media) elements.push(media)

		if (slice.image_position === 'left' && elements.length > 1) {
			elements = elements.reverse()
		}

		if (sidebar) {
			elements.push(sidebar)
		}

		var className = slice.image_first_at_mobile && elements.length > 1 ? 'column-blocks image-first-at-mobile' : 'column-blocks'

		if (sidebar) {
			className += ' with-sidebar'
		}

		// if there's only a single column, add the --single-column class
		if (elements.length === 1 && !media) {
			className += ' column-blocks--single-column'

			// if this single column is a media type, add a class to handle center alignment
			// if( media )
			// {
			//     className += ' column-blocks--center-media';
			// }
		}

		var block = '<div class="' + className + '">'
		block += elements.join('')
		block += '</div>'

		return block
	}

	this.getVideoSlug = function (url) {
		var link = document.createElement('a')
		link.href = url

		// remove the leading slash to normalize the input
		var path = link.pathname.substring(1)

		// always want the first index
		var segments = path.split('/')

		return segments[0]
	}

	this.activateRequestedTab = () => {
		const params = getRequestParams()

		if (params.tab) {
			const tab = document.querySelector(`[id="${params.tab}"]`)
			if (tab) tab.click()
		}
	}

	this.init = function (data) {
		if (data.container && data.slices.length) {
			this.root = document.getElementById(data.container)
			this.tabFontSize = data.tab_font_size
			this.slices = data.slices
		}

		window.addEventListener('resize', this.resize.bind(this), true)

		window.addEventListener('ExpandTabAccordion', this.updateItemIndex.bind(this))

		this.resize()

		this.activateRequestedTab()
	}
}

export default TabbedContentAccordion
